import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import L from "leaflet";

export default function SpotMap({ spots, activeId, onSelect, height = "100%" }) {
  const mapRef = useRef(null);
  const containerRef = useRef(null);
  const markersRef = useRef({});
  const navigate = useNavigate();

  useEffect(() => {
    if (mapRef.current || !containerRef.current) return;
    const map = L.map(containerRef.current, {
      center: [46.6, 2.4],
      zoom: 5.5,
      scrollWheelZoom: true,
      zoomControl: true,
    });
    L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "© OpenStreetMap",
      maxZoom: 19,
    }).addTo(map);
    mapRef.current = map;
  }, []);

  useEffect(() => {
    const map = mapRef.current;
    if (!map) return;
    Object.values(markersRef.current).forEach((m) => map.removeLayer(m));
    markersRef.current = {};

    spots.forEach((s) => {
      const icon = L.divIcon({
        className: "pesche-pin",
        html: `<div class="${s.id === activeId ? "active" : ""}"><span>🎣</span></div>`,
        iconSize: [34, 34],
        iconAnchor: [17, 34],
      });
      const marker = L.marker([s.lat, s.lng], { icon }).addTo(map);
      marker.bindPopup(
        `<div style="font-family:'DM Sans';min-width:160px">
           <strong style="font-family:'Outfit';color:#113027">${s.name}</strong>
           <div style="color:#059669;font-size:12px;margin:2px 0">${s.water_type}</div>
           <div style="font-size:12px;color:#555">${s.region}</div>
           <button id="popup-${s.id}" style="margin-top:6px;background:#059669;color:#fff;border:none;padding:5px 10px;border-radius:8px;font-size:12px;cursor:pointer;font-weight:600">Voir le spot →</button>
         </div>`
      );
      marker.on("click", () => onSelect && onSelect(s.id));
      marker.on("popupopen", () => {
        const btn = document.getElementById(`popup-${s.id}`);
        if (btn) btn.onclick = () => navigate(`/spots/${s.id}`);
      });
      markersRef.current[s.id] = marker;
    });
  }, [spots, activeId, onSelect, navigate]);

  useEffect(() => {
    const map = mapRef.current;
    const spot = spots.find((s) => s.id === activeId);
    if (map && spot) {
      map.flyTo([spot.lat, spot.lng], 8, { duration: 0.8 });
      const m = markersRef.current[activeId];
      if (m) m.openPopup();
    }
  }, [activeId, spots]);

  return <div ref={containerRef} data-testid="spot-map" style={{ height, width: "100%", borderRadius: "1rem", zIndex: 0 }} />;
}
